"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _NumberFormat = _interopRequireDefault(require("../../NumberFormat"));

var _Buttons = require("../../Buttons");

var _Icon = _interopRequireDefault(require("../../Icon/Icon"));

var _MarketplaceProductImage = _interopRequireDefault(require("../MarketplaceProductImage/MarketplaceProductImage"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var _root;

  var spacing = _ref.spacing,
      palette = _ref.palette,
      breakpoints = _ref.breakpoints;
  return {
    root: (_root = {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      padding: spacing(1),
      flex: '1 1 294px',
      boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.1), 0 0 2px 0 rgba(0, 0, 0, 0.5)',
      '&:hover $actionBox': {
        display: 'flex'
      }
    }, (0, _defineProperty2["default"])(_root, breakpoints.down('xs'), {
      maxWidth: 'calc(50% - 1em)'
    }), (0, _defineProperty2["default"])(_root, breakpoints.up('sm'), {
      maxWidth: 'calc(33.33% - 1em)'
    }), (0, _defineProperty2["default"])(_root, breakpoints.up('md'), {
      maxWidth: 'calc(25% - 1em)'
    }), _root),
    added: {
      border: "2px solid ".concat(palette.green.dark),
      borderRadius: '5px'
    },
    image: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: '0 0 auto',
      height: 220,
      maxHeight: 220
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      flex: '1 1 auto',
      marginTop: spacing(0.5)
    },
    summary: {
      display: 'flex',
      flexWrap: 'nowrap',
      justifyContent: 'space-between'
    },
    flagIcon: {
      flex: '0 0 24px',
      height: 24,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
      '& > img': {
        height: '100%'
      }
    },
    addedMark: {
      flex: '0 0 32px',
      backgroundColor: palette.green.dark,
      height: 32,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: palette.common.white
    },
    title: {
      fontSize: 16,
      lineHeight: '24px',
      color: palette.text.primary,
      wordBreak: 'break-all'
    },
    subtitle: {
      fontSize: 12,
      lineHeight: '16px',
      color: palette.grey.main
    },
    price: {
      marginTop: spacing(0.5),
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 700,
      color: palette.text.primary
    },
    actionBox: {
      display: 'none',
      position: 'absolute',
      width: '100%',
      height: '100%',
      margin: "-".concat(spacing(1)),
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      backgroundColor: 'rgba(255, 255, 255, .82)'
    }
  };
});
var MarketplaceGridItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var price = _ref2.price,
      title = _ref2.title,
      _ref2$currency = _ref2.currency,
      currency = _ref2$currency === void 0 ? '$' : _ref2$currency,
      _ref2$subtitle = _ref2.subtitle,
      subtitle = _ref2$subtitle === void 0 ? '' : _ref2$subtitle,
      _ref2$image = _ref2.image,
      image = _ref2$image === void 0 ? '' : _ref2$image,
      flag = _ref2.flag,
      hasExternalFulfillment = _ref2.hasExternalFulfillment,
      _ref2$added = _ref2.added,
      added = _ref2$added === void 0 ? false : _ref2$added,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      onClickAdd = _ref2.onClickAdd,
      onClickPreview = _ref2.onClickPreview,
      onClickRemove = _ref2.onClickRemove,
      showStarOnPrice = _ref2.showStarOnPrice,
      className = _ref2.className,
      boxProps = (0, _objectWithoutProperties2["default"])(_ref2, ["price", "title", "currency", "subtitle", "image", "flag", "hasExternalFulfillment", "added", "disabled", "onClickAdd", "onClickPreview", "onClickRemove", "showStarOnPrice", "className"]);
  var classes = useStyles();
  var isActionUsed = !!onClickAdd || !!onClickPreview || !!onClickRemove;
  var showSubtitle = subtitle && !hasExternalFulfillment;
  return /*#__PURE__*/_react["default"].createElement(_material.Box, (0, _extends2["default"])({
    ref: ref,
    className: (0, _classnames["default"])(classes.root, className, (0, _defineProperty2["default"])({}, classes.added, added))
  }, boxProps), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.image
  }, /*#__PURE__*/_react["default"].createElement(_MarketplaceProductImage["default"], {
    src: image
  })), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.details
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.title
  }, title), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.summary
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, null, showSubtitle && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.subtitle
  }, subtitle), typeof price === 'number' && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.price
  }, currency, /*#__PURE__*/_react["default"].createElement(_NumberFormat["default"], null, price), " ", showStarOnPrice ? '*' : '')), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    justifyContent: "right"
  }, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.flagIcon
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: flag,
    alt: "Product country"
  })), added && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.addedMark,
    ml: 1
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "check"
  }))))), isActionUsed && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    className: classes.actionBox
  }, (onClickAdd || onClickRemove) && /*#__PURE__*/_react["default"].createElement(_material.Box, {
    pb: 4
  }, onClickAdd && /*#__PURE__*/_react["default"].createElement(_Buttons.Button, {
    onClick: onClickAdd,
    disabled: disabled,
    color: "secondary",
    startIcon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "plus"
    })
  }, "Add to Marketplace"), onClickRemove && /*#__PURE__*/_react["default"].createElement(_Buttons.Button, {
    onClick: onClickRemove,
    disabled: disabled,
    color: "orange",
    startIcon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "minus"
    })
  }, "Remove from Marketplace")), onClickPreview && /*#__PURE__*/_react["default"].createElement(_Buttons.Button, {
    onClick: onClickPreview,
    borderColor: "divider",
    startIcon: /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: "eye"
    })
  }, "View Details")));
});

var _default = /*#__PURE__*/(0, _react.memo)(MarketplaceGridItem);

exports["default"] = _default;